import { Locales } from "@/enums/enums";
import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./en.json";
import th from "./th.json";
Vue.use(VueI18n);

const messages = {
  [Locales.EN]: en,
  [Locales.TH]: th,
};

const defaultLocale = Locales.TH;

export const i18n = new VueI18n({
  messages,
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  silentTranslationWarn: true,
});
